import { Box, Button } from '@factorialco/deprecated-design-system'
import { TrainingSessionsByEmployeeDataTableQuery } from 'generated/resources/datatable.graphql'

import { useDataTable } from 'modules/core/components/DataTable'
import PopoverMenu from 'modules/core/components/PopoverMenu'
import i18n from 'modules/core/lib/i18n'

import { AttendanceButton } from './AttendanceButton'

type TrainingsSessionAccessMembership = NonNullable<
  NonNullable<
    NonNullable<
      NonNullable<TrainingSessionsByEmployeeDataTableQuery['trainings']>['sessionsConnection']
    >['edges'][0]
  >['node']
>

export const BulkUpdateAttendanceAction = ({ accessId }: { accessId: string }) => {
  const { data, selectedRows } = useDataTable<
    TrainingSessionsByEmployeeDataTableQuery,
    TrainingsSessionAccessMembership
  >()
  const sessionsArray = [...selectedRows]
    .map((value) => {
      return data.find((session) => session.id === String(value))
    })
    .filter(Boolean)

  const sessionAttendances = sessionsArray
    .flatMap((session) => session.sessionAttendances)
    .filter((attendance) => attendance.accessId === accessId)
    .map((att) => att.id)

  return (
    <Box flexDirection="row" gap="s8">
      <PopoverMenu type="dialog">
        <PopoverMenu.Trigger asChild disabled={selectedRows.size === 0}>
          <Button type="secondary" disabled={selectedRows.size === 0} iconName="refresh">
            {i18n.t(
              'trainings.trainings_revamp.employee_sidepanel.datatable.reviewed_update_action'
            )}
          </Button>
        </PopoverMenu.Trigger>
        <PopoverMenu.Content side="bottom" align="end">
          <Box gap="s12" padding="s12">
            <AttendanceButton status="pending" idsAttendance={sessionAttendances} />
            <AttendanceButton status="inprogress" idsAttendance={sessionAttendances} />
            <AttendanceButton status="completed" idsAttendance={sessionAttendances} />
            <AttendanceButton status="missing" idsAttendance={sessionAttendances} />
          </Box>
        </PopoverMenu.Content>
      </PopoverMenu>
    </Box>
  )
}
